var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3210_56223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 11.8C33 12.3 32.5 12.8 32 12.8C31.5 12.8 31 12.3 31 11.8V1C31 0.4 31.5 0 32 0C32.5 0 33 0.4 33 1V11.8Z",
    fill: "#B2C1C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 28H60V60H4V28Z",
    fill: "#E5DEC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4995 19.8C59.9995 18.8 58.6995 18 57.4995 18H6.39955C5.29955 18 3.89955 18.8 3.39955 19.8L0.0995453 26.2C-0.400455 27.2 0.0995454 28 1.19955 28H62.5995C63.6995 28 64.1995 27.2 63.6995 26.2L60.4995 19.8Z",
    fill: "#D33B23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 45C15 45.5 14.6 46 14 46H8C7.4 46 7 45.5 7 45V41C7 40.5 7.4 40 8 40H14C14.6 40 15 40.5 15 41V45Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 35C15 35.5 14.6 36 14 36H8C7.4 36 7 35.5 7 35V31C7 30.5 7.4 30 8 30H14C14.6 30 15 30.5 15 31V35Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 36.5H8C7.2 36.5 6.5 35.8 6.5 35V31C6.5 30.2 7.2 29.5 8 29.5H14C14.8 29.5 15.5 30.2 15.5 31V35C15.5 35.8 14.8 36.5 14 36.5ZM8 30.5C7.7 30.5 7.5 30.7 7.5 31V35C7.5 35.3 7.7 35.5 8 35.5H14C14.3 35.5 14.5 35.3 14.5 35V31C14.5 30.7 14.3 30.5 14 30.5H8Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 30H11.5V36H10.5V30Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 47H8C7.2 47 6.5 46.3 6.5 45.5V41.5C6.5 40.7 7.2 40 8 40H14C14.8 40 15.5 40.7 15.5 41.5V45.5C15.5 46.3 14.8 47 14 47ZM8 41C7.7 41 7.5 41.2 7.5 41.5V45.5C7.5 45.8 7.7 46 8 46H14C14.3 46 14.5 45.8 14.5 45.5V41.5C14.5 41.2 14.3 41 14 41H8Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 40.5H11.5V46.5H10.5V40.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 55C15 55.5 14.6 56 14 56H8C7.4 56 7 55.5 7 55V51C7 50.5 7.4 50 8 50H14C14.6 50 15 50.5 15 51V55Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 57H8C7.2 57 6.5 56.3 6.5 55.5V51.5C6.5 50.7 7.2 50 8 50H14C14.8 50 15.5 50.7 15.5 51.5V55.5C15.5 56.3 14.8 57 14 57ZM8 51C7.7 51 7.5 51.2 7.5 51.5V55.5C7.5 55.8 7.7 56 8 56H14C14.3 56 14.5 55.8 14.5 55.5V51.5C14.5 51.2 14.3 51 14 51H8Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 50.5H11.5V56.5H10.5V50.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 45C57 45.5 56.5 46 56 46H50C49.5 46 49 45.5 49 45V41C49 40.5 49.5 40 50 40H56C56.5 40 57 40.5 57 41V45Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 35C57 35.5 56.5 36 56 36H50C49.5 36 49 35.5 49 35V31C49 30.5 49.5 30 50 30H56C56.5 30 57 30.5 57 31V35Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 36.5H50C49.2 36.5 48.5 35.8 48.5 35V31C48.5 30.2 49.2 29.5 50 29.5H56C56.8 29.5 57.5 30.2 57.5 31V35C57.5 35.8 56.8 36.5 56 36.5ZM50 30.5C49.7 30.5 49.5 30.7 49.5 31V35C49.5 35.3 49.7 35.5 50 35.5H56C56.3 35.5 56.5 35.3 56.5 35V31C56.5 30.7 56.3 30.5 56 30.5H50Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 30H53.5V36H52.5V30Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 47H50C49.2 47 48.5 46.3 48.5 45.5V41.5C48.5 40.7 49.2 40 50 40H56C56.8 40 57.5 40.7 57.5 41.5V45.5C57.5 46.3 56.8 47 56 47ZM50 41C49.7 41 49.5 41.2 49.5 41.5V45.5C49.5 45.8 49.7 46 50 46H56C56.3 46 56.5 45.8 56.5 45.5V41.5C56.5 41.2 56.3 41 56 41H50Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 40.5H53.5V46.5H52.5V40.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 55C57 55.5 56.5 56 56 56H50C49.5 56 49 55.5 49 55V51C49 50.5 49.5 50 50 50H56C56.5 50 57 50.5 57 51V55Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 57H50C49.2 57 48.5 56.3 48.5 55.5V51.5C48.5 50.7 49.2 50 50 50H56C56.8 50 57.5 50.7 57.5 51.5V55.5C57.5 56.3 56.8 57 56 57ZM50 51C49.7 51 49.5 51.2 49.5 51.5V55.5C49.5 55.8 49.7 56 50 56H56C56.3 56 56.5 55.8 56.5 55.5V51.5C56.5 51.2 56.3 51 56 51H50Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 50.5H53.5V56.5H52.5V50.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8003 11.6C32.4003 11.3 31.7003 11.3 31.2003 11.6L11.8003 27.4C11.4003 27.7 11.4003 28 12.0003 28H52.0003C52.5003 28 52.7003 27.7 52.2003 27.4L32.8003 11.6Z",
    fill: "#F15744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1996 27.3998L32.7996 14.5998C32.3996 14.1998 31.6996 14.1998 31.2996 14.5998L15.7996 27.3998C15.2996 27.6998 15.3996 27.9998 15.9996 27.9998H17.9996V59.9998H45.9996V27.9998H47.9996C48.4996 27.9998 48.6996 27.6998 48.1996 27.3998Z",
    fill: "#F9F3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 45H40V60H24V45Z",
    fill: "#E5DEC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 45H38V60H26V45Z",
    fill: "#42ADE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1996 38C20.4996 38.1 20.8996 38.2 21.2996 38.2C21.7996 38.2 21.9996 38 21.9996 37.8C21.9996 37.6 21.7996 37.4 21.2996 37.3C20.5996 37.1 20.0996 36.7 20.0996 36.2C20.0996 35.5 20.6996 35 21.7996 35C22.2996 35 22.6996 35.1 22.8996 35.2L22.6996 35.9C22.4996 35.8 22.1996 35.7 21.7996 35.7C21.3996 35.7 21.1996 35.9 21.1996 36.1C21.1996 36.3 21.3996 36.5 21.9996 36.6C22.7996 36.9 23.0996 37.2 23.0996 37.8C23.0996 38.4 22.4996 39 21.2996 39C20.7996 39 20.2996 38.9 20.0996 38.8L20.1996 38Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9 38.8C26.7 38.9 26.3 39 25.8 39C24.3 39 23.5 38.2 23.5 37.1C23.5 35.8 24.6 35 25.9 35C26.4 35 26.8 35.1 27 35.2L26.8 35.9C26.6 35.8 26.3 35.8 26 35.8C25.2 35.8 24.6 36.2 24.6 37.1C24.6 37.9 25.1 38.4 26 38.4C26.3 38.4 26.6 38.3 26.8 38.3L26.9 38.8Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 35.1001V36.6001H30.1V35.1001H31.1V39.0001H30.1V37.4001H28.5V39.0001H27.5V35.1001H28.5Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9996 37C35.9996 38.3 35.0996 39 33.8996 39C32.5996 39 31.7996 38.1 31.7996 37C31.7996 35.8 32.5996 35 33.8996 35C35.1996 35 35.9996 35.9 35.9996 37ZM32.7996 37C32.7996 37.8 33.1996 38.3 33.8996 38.3C34.5996 38.3 34.8996 37.7 34.8996 37C34.8996 36.3 34.4996 35.7 33.7996 35.7C33.1996 35.7 32.7996 36.3 32.7996 37Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5997 37C40.5997 38.3 39.6997 39 38.4997 39C37.1997 39 36.3997 38.1 36.3997 37C36.3997 35.8 37.1997 35 38.4997 35C39.8997 35 40.5997 35.9 40.5997 37ZM37.4997 37C37.4997 37.8 37.8997 38.3 38.5997 38.3C39.2997 38.3 39.5997 37.7 39.5997 37C39.5997 36.3 39.1997 35.7 38.4997 35.7C37.8997 35.7 37.4997 36.3 37.4997 37Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2996 35.1001H42.2996V38.2001H43.9996V38.9001H41.2996V35.1001Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 33C35.866 33 39 29.866 39 26C39 22.134 35.866 19 32 19C28.134 19 25 22.134 25 26C25 29.866 28.134 33 32 33Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 31C34.7614 31 37 28.7614 37 26C37 23.2386 34.7614 21 32 21C29.2386 21 27 23.2386 27 26C27 28.7614 29.2386 31 32 31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 45H32.5V60H31.5V45Z",
    fill: "#E5DEC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 22C31.5 22 31 22.5 31 23V27C31 27.5 31.5 28 32 28C32.5 28 33 27.5 33 27V23C33 22.5 32.5 22 32 22Z",
    fill: "#B2C1C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 26H30C29.5 26 29 26.5 29 27C29 27.5 29.5 28 30 28H32C32.5 28 33 27.5 33 27C33 26.5 32.5 26 32 26Z",
    fill: "#F15744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 2V9.4C37 12.6 41 2.5 45 5.7C41 0 37 7.6 33 2Z",
    fill: "#B4D7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9 40.3C32.4 39.9 31.5 39.9 31 40.3C28.9 41.8 22 46 22 46V48H42V46C42 46 35.1 41.8 32.9 40.3Z",
    fill: "#F15744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 60H1C0.4 60 0 60.5 0 61V63C0 63.5 0.4 64 1 64H63C63.5 64 64 63.5 64 63V61C64 60.5 63.5 60 63 60Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 62H44V64H20V62Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 60H42V62H22V60Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0996 53.5H30.4996V54.2H29.0996V53.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 53.5H34.9V54.2H33.5V53.5Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3210_56223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientSchool);
export default __webpack_public_path__ + "static/media/client-school.071481ffa6bcd7b06c4e0c0fe2209ff6.svg";
export { ForwardRef as ReactComponent };